import React from 'react';
import { cn } from '@/utils';

export const PageContainer = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <div className={cn('', className)} {...rest} />;
};

export const PageBackgroundNarrow = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  const hasBackground = className?.includes('bg-') && !className.includes('bg-transparent');

  return (
    <div
      className={cn(
        '',
        hasBackground ? 'shadow-lg-full relative z-10 m-auto max-w-[1440px]' : 'relative',
        className,
      )}
      {...rest}
    />
  );
};

export const PageBackgroundWide = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  const hasBackground = className?.includes('bg-') && !className.includes('bg-transparent');

  return (
    <div
      className={cn(
        '',
        hasBackground ? 'relative z-10 md:m-8 md:rounded-xl' : 'relative',
        className,
      )}
      {...rest}
    />
  );
};

export const PageBackgroundFull = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  const hasBackground = className?.includes('bg-') && !className.includes('bg-transparent');

  return (
    <div
      className={cn('', hasBackground ? 'shadow-lg-full relative z-10' : 'relative', className)}
      {...rest}
    />
  );
};

export const PageSectionSmall = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <div className={cn('m-auto max-w-[1280px]', className)} {...rest} />;
};

export const PageSectionMedium = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <div className={cn('m-auto max-w-[1280px]', className)} {...rest} />;
};

export const PageSectionLarge = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-[1280px] space-y-4 px-4 py-4 sm:px-6 md:py-8 lg:px-8 lg:py-12',
        className,
      )}
      {...rest}
    />
  );
};

export const PageSectionDashboard = ({ className, ...rest }: React.ComponentProps<'div'>) => {
  return <div className={cn('space-y-6 p-4 md:p-8', className)} {...rest} />;
};
